<template>
  <div v-loading="dataLoading" class="app-content-wrapper">
    <el-form class="form-wrapper" :model="form" ref="formRef" :rules="formRules" label-position="top">
      <el-form-item :label="$t('message.permission.roleName')" prop="roleName" style="width: 730px">
        <el-input v-model="form.roleName" :placeholder="$t('message.validator.input', { input: $t('message.permission.roleName') })"></el-input>
      </el-form-item>
      <div class="split-line"></div>
      <el-form-item :label="$t('message.permission.rolePermission')" style="width: 730px">
        <role-tree :isEdit="isEdit" :list.sync="resourceIdArr"></role-tree>
      </el-form-item>
      <div v-if="isEdit" class="margin-top-25 margin-bottom-25">
        <el-button
          type="primary"
          :loading="requesting"
          @click="handleSubmit">
          {{ $t("message.common.submit") }}
        </el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import { getRoleDetail, getRolePermission, updateRole } from '@/views/account/permission/api/role';
import RoleTree from '@/views/account/permission/role/role-tree/index.vue';

export default {
  components: {
    RoleTree,
  },
  data() {
    return {
      dataLoading: false,
      requesting: false,
      form: {
        roleName: '',
      },
      formRules: {
        roleName: [{ required: true, message: this.$t('message.validator.input', { input: this.$t('message.permission.roleName') }), trigger: 'blur' }],
      },
      resourceIdArr: [],
      roleInfo: {},
      isEdit: true,
    };
  },
  created() {
    const roleId = this.$route.query.id;
    this.isEdit = !!(+this.$route.query.flag);
    this.fetchInitData(roleId);
  },
  methods: {
    // 获取对象数组中指定key的值
    getValuesByKeyFromArrayObject(arr, key) {
      const values = [];
      if (arr.length) {
        for (let i = 0; i < arr.length; i++) {
          values.push(arr[i][key]);
        }
      }
      return values;
    },
    async fetchInitData(roleId) {
      this.dataLoading = true;
      try {
        const info = await getRoleDetail(roleId);
        this.roleInfo = info;
        this.form.roleName = info.roleName;
        const res = await getRolePermission(roleId);
        this.resourceIdArr = this.getValuesByKeyFromArrayObject(res, 'resourceId');
      } catch (err) {
      }
      this.dataLoading = false;
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          if (!this.resourceIdArr.length) {
            this.$message.error(this.$t('message.validator.select', { select: this.$t('message.permission.permission') }));
            return;
          }
          const roleData = {
            roleName: this.form.roleName,
            resourceId: this.resourceIdArr,
            id: this.roleInfo.id,
          };
          this.requesting = true;
          try {
            await updateRole(roleData);
            ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
            this.$router.go(-1);
          } catch (err) {
          }
          this.requesting = false;
        } else {
          this.$nextTick(() => {
            const errorDom = document.querySelector('.is-error');
            if (errorDom) {
              errorDom.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.form-wrapper {
  margin-top: 20px;
}

.split-line {
  border-bottom: 1px solid rgba(0,32,63,0.08);
  margin-bottom: 20px;
}
</style>
